export default "__VITE_ASSET__CFzACHYh__"